import {
  createTheme,
  IconButton,
  ThemeProvider,
  Typography,
} from "@mui/material";
import React, { ReactNode, useState } from "react";

import FilterVintageIcon from "@mui/icons-material/FilterVintage";

import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import { orange } from "@mui/material/colors";

interface WidgetComponentProps {
  header: () => JSX.Element;
  children: ReactNode;
}

const customTheme = createTheme({
  palette: {
    primary: {
      main: orange[800],
    },
  },
});

const WidgetComponent: React.FC<WidgetComponentProps> = ({
  header,
  children,
}) => {
  const [size, setSize] = useState(false);
  return (
    <ThemeProvider theme={customTheme}>
      <div className="slot-container">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            background: "whitesmoke",
          }}
        >
          {!size && (
            <Typography style={{ margin: "5px" }}>Search data</Typography>
          )}
          {size && header()}
          <IconButton
            aria-label="minimalism"
            size="medium"
            title="Minimize"
            disableRipple
            onClick={() => {
              setSize((s) => !s);
            }}
          >
            {size ? (
              <FilterVintageIcon fontSize="inherit" />
            ) : (
              <CloseFullscreenIcon fontSize="inherit" />
            )}
          </IconButton>
        </div>

        <div
          className="slot-content"
          style={{
            maxHeight: `${size ? "0px" : "90vh"}`,
            width: `${!size ? "300px" : "0px"}`,
            transition: "max-height 0.05s ease-in-out",
            overflow: "hidden",
          }}
        >
          {children}
        </div>
      </div>
    </ThemeProvider>
  );
};

export default WidgetComponent;
